<template>
  <div class="blog-header">
    <span v-if="description" class="blog-header__description">
      {{ description }}
    </span>
    <span v-if="author" class="blog-header__origin">
      {{ author }},
      <time :datetime="createdAt">{{ getDate(createdAt) }}</time>
    </span>
  </div>
</template>

<script>
  import { format } from 'date-fns'

  export default {
    props: {
      description: {
        type: String,
        default: null,
      },
      author: {
        type: String,
        default: null,
      },
      createdAt: {
        type: String,
        default: null,
      },
    },
    methods: {
      getDate(date) {
        return format(new Date(date), 'dd.MM.yyyy')
      },
    },
  }
</script>

<style lang="scss" src="./_blog-header.scss" />
